import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useFormContext } from "react-hook-form";

import { isValidEmail } from "helpers/validationHelpers";
import Input from "components/atoms/Input/Input";
import Checkbox from "components/atoms/Checkbox/Checkbox";
import DatePicker from "components/atoms/DatePicker/DatePicker";
import TimeInput from "components/atoms/TimeInput/TimeInput";


const NotificationEmailDelegate = function () {
  const intl = useIntl();
  const { watch } = useFormContext();
  const isDelegatesEmailEnabled = watch("delegates.email_delegate");

  return (
    <div className="mt-4">
      <Checkbox
        providerSections
        checkboxLabel={intl.formatMessage({
          id: "settings.notifications.identityEmailDelegate",
          defaultMessage: "Identify email delegate",
        })}
        name="delegates.email_delegate"
        required={false}
      >
        <div className="d-flex flex-column pt-15">
          <div className="mb-2 d-flex flex-wrap">
            <div className="mr-3 mb-xs-2">
              <div className="mb-2 font-b3">
                <FormattedMessage id="settings.notifications.delegateEmailAddress" defaultMessage="Delegate email address" />
              </div>
              <Input
                type="text"
                name="delegates.delegate_email_address"
                placeholder={intl.formatMessage({
                  id: "settings.notifications.delegateEmailAddress",
                  defaultMessage: "Delegate email address",
                })}
                eventContext="Settings - Notifications"
                required={isDelegatesEmailEnabled}
                validations={{
                  validate: {
                    validEmail: (v) =>
                      isValidEmail(v) ||
                      intl.formatMessage({
                        id: "general.invalidEmail",
                        defaultMessage: "Invalid Email",
                      }),
                  },
                }}
                className="w-100 rounded-input"
              />
            </div>
            <div className="mr-3">
              <div className="mb-2 font-b3">
                <FormattedMessage id="settings.notifications.delegationEndDate" defaultMessage="Delegation end date" />
              </div>
              <DatePicker
                name="delegates.delegate_expiration_date"
                minDate={new Date()}
                required={isDelegatesEmailEnabled}
                eventContext="Settings - Notifications"
              />
            </div>

            <div>
              <div className="mb-2 font-b3">
                <FormattedMessage id="settings.notifications.delegationEndTime" defaultMessage="Delegation end time" />
              </div>
              <TimeInput
                name="delegates.delegate_expiration_time"
                required={isDelegatesEmailEnabled}
                eventContext="Settings - Notifications"
                outputFormat="HH:mm"
              />
            </div>
          </div>
          <div className="text-secondary font-b3">
            <FormattedMessage
              id="settings.notifications.emailDelegateIndo"
              defaultMessage="The email delegate will receive your notifications, but requires a personal Cargobase account to follow up on actions."
            />
          </div>
        </div>
      </Checkbox>
    </div>
  );
};

export default NotificationEmailDelegate;
